import React from 'react';
import { contactInfo } from '../data/mock';

// Real brand logo (Dawn's logo card image, cropped visually via object-position)
const LotusLogo = ({ className = 'w-24 h-24', color, rounded = true }) => (
  <img
    src={contactInfo.brandLogoUrl}
    alt="Blissfull Mobile Spa"
    className={`${className} ${rounded ? 'rounded-xl' : ''} object-cover shadow-lg`}
    loading="lazy"
    // eslint-disable-next-line no-unused-vars
    data-color={color}
  />
);

export default LotusLogo;
